module.exports = __webpack_public_path__ + "mine-fill.jpg?460888f468403a616c2c1db7bab23a2d";